import React from 'react';
import { Image, View } from 'react-native';
import { img_go } from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const ArrowInsideSmallSquareBtn = ({
  globJSON, isPrimaryCtaColorBackground, perfectSquare,
}) => {
  const getRadius = perfectSquare ? 23 : 15;
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      width: !perfectSquare && 254, alignItems: 'center',
    },
    child: {
      width: perfectSquare ? 46 : 41,
      height: perfectSquare ? 46 : 29,
      backgroundColor: isPrimaryCtaColorBackground ? colors.primary_cta_color : colors.disabled_cta_color,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : getRadius,
      justifyContent: 'center',
      alignItems: 'center',
    },
    imageStyle: {
      width: 21,
      height: 21,
      tintColor: colors.cta_font_color,
    },
  };

  return (
    <View style={myStyles.container}>
      <View style={myStyles.child}>
        <Image
          fadeDuration={0}
          style={myStyles.imageStyle}
          source={img_go}
        />
      </View>
    </View>
  );
};
export default ArrowInsideSmallSquareBtn;
